<template>
  <section id="privacy-cloud-infor" class="privacy-cloud-infor">
    <div
      class="privacy-cloud-infor-mobile-background"
      :class="lang === 'zh' ? 'privacy-cloud-infor-mobile-background-zh' : ''"
    ></div>
    <div class="privacy-cloud-infor-sticky" :class="lang === 'zh' ? 'privacy-cloud-infor-sticky-zh' : ''">
      <div v-textMotion class="text-intro cloud-infor-text-intro">
        <p class="title">{{ $t('cloud-infor-title') }}</p>
        <p class="sub-title">{{ $t('cloud-infor-sub-title') }}</p>
        <p class="description">{{ $t('cloud-infor-description') }}</p>
      </div>
      <div
        class="cloud-infor-lottie-container wow textInPartMotion"
        :class="lottieMobileGoToTop ? 'cloud-infor-lottie-container-gototop' : ''"
        data-wow-offset="100"
        data-wow-duration="0.3s"
        data-wow-delay="1s"
      >
        <div class="cloud-infor-lottie"></div>
      </div>
    </div>
  </section>
</template>
<script>
import ScrollMagic from 'scrollmagic';
import lottie from 'lottie-web/build/player/lottie_svg.min';
import Controller from '../../util/scrollMagic';
import UpdateAnimationMixin from '../../mixins/updateAnimation';

export default {
  inject: ['vm', 'lang'],
  mixins: [UpdateAnimationMixin],
  data() {
    return {
      progress: 0,
      phoneActive: false,
      phoneOpacity: 0,
      lottieEnter: 0,
      separationMobilePhoneActive: false,
      lottieMobileGoToTop: false
    };
  },

  mounted() {
    this.clientHeight = window.innerHeight;
    this.resizeHandler();
    this.loadAnimation();
    window.addEventListener('resize', this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    loadAnimationPlay() {
      // if (this.vm.isMobile) {
      setTimeout(
        () => {
          console.log('palyicon lottie', this.animation);
          this.animation.play();
        },
        this.lottieEnter === 1 ? (this.vm.isMobile ? 1000 : 2000) : 0
      );
      // } else {
      //   this.animation.goToAndStop((86 * Math.min(0.5, this.progress)) / 0.5, true);
      // }
    },
    loadAnimation() {
      new ScrollMagic.Scene({
        triggerElement: '.privacy-cloud-infor',
        triggerHook: 1
      })
        .addTo(Controller)
        .on('enter', () => {
          if (this.lottieLoaded) return;
          this.lottieLoaded = true;
          import(`./lottie/cloudInfor${this.lang === 'zh' ? 'Zh' : ''}.json`).then(animationData => {
            animationData.assets.forEach((item, index) => {
              if (item.p) {
                // get from https://github.com/facebook/jest/issues/7271 and jianshu.com/p/78f7b19932cb
                item.u = '';
                item.p = require(`./lottie/cloudInforImages${this.lang === 'zh' ? 'Zh' : ''}/img_` + index + '.png');
              }
            });
            this.animation = lottie.loadAnimation({
              container: document.querySelector('.cloud-infor-lottie'),
              renderer: 'svg',
              loop: false,
              autoplay: false,
              animationData
            });
            this.animation.addEventListener('complete', () => {
              this.lottieMobileGoToTop = true;
            });
            if (this.lottieEnter) {
              this.loadAnimationPlay();
            }
          });
        });

      setTimeout(() => {
        new ScrollMagic.Scene({
          triggerElement: '.cloud-infor-lottie-container',
          triggerHook: 1,
          duration: this.vm.isMobile ? 0 : window.innerHeight,
          offset: 100
        })
          .addTo(Controller)
          .on('enter', () => {
            console.log('cloudInfor', +new Date());
            this.lottieEnter++;
            if (this.animation) {
              this.loadAnimationPlay();
            }
          })
          .on('leave', e => {
            this.lottieMobileGoToTop = false;
            if (this.animation && e.scrollDirection === 'FORWARD' && this.vm.isMobile) this.animation.stop();
          });
      }, 300);

      // new ScrollMagic.Scene({
      //   triggerElement: '.privacy-codebook',
      //   triggerHook: 0,
      //   offset: 500
      // })
      //   .addTo(Controller)
      //   .on('enter', e => {
      //     console.log('2 enter');
      //     console.log('2 leave');
      //     this.lottieMobileGoToTop = false;
      //     if (this.animation) this.animation.stop();
      //   })
      //   .on('leave', () => {
      //     this.lottieEnter++;
      //     if (this.animation) {
      //       this.loadAnimationPlay();
      //     }
      //   });

      new ScrollMagic.Scene({
        triggerElement: '.cloud-infor-lottie-container',
        triggerHook: 1,
        offset: -100
      })
        .addTo(Controller)
        .on('leave', () => {
          if (this.animation && this.vm.isMobile) this.animation.stop();
        });
    },
    initScroll() {
      this.scene = new ScrollMagic.Scene({
        duration: 0.5 * this.clientHeight,
        triggerElement: '.privacy-cloud-infor',
        triggerHook: 0
      })
        .setPin('.privacy-cloud-infor-sticky')
        .addTo(Controller)
        .on('progress', e => {
          this.updateBezier('progress', e.progress, 500);
        });
    },

    resizeHandler() {
      if (this.scene) this.scene.duration(0.5 * this.clientHeight);
    }
  }
};
</script>
